import createCommonModule from '@/common/store/modules/common';
import actions from '@/common/store/modules/domains/domains.actions';
import mutations from '@/common/store/modules/domains/domains.mutations';
import getters from '@/common/store/modules/domains/domains.getters';
import Domain from '@/common/store/modules/domains/createDomain';

export default createCommonModule({
  resource: '/api/v2/domains',
  Model: Domain,
  state: {
    props: []
  },
  config: {
    updateMethod: 'put'
  },
  actions,
  mutations,
  getters
});
